import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function CTASection() {
  return <section className="w-full py-20 px-4 bg-cream" data-id="element-34">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto text-center" data-id="element-35">
        <h2 className="font-handwriting text-5xl md:text-6xl text-forest mb-6" data-id="element-36">
          Auch dein Hund verdient einen ruhigen Bauch
        </h2>

        <p className="font-serif text-xl text-brown-dark/80 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-37">
          Teste das Magen-Darm-Topping jetzt risikofrei – mit
          Geld-zurück-Garantie. Keine Chemie. Nur Natur.
        </p>

        <a href="https://hunderunde.shop/products/futtertopping-magen-darm" target="_blank" rel="noopener noreferrer" className="inline-block bg-forest hover:bg-forest-light text-cream font-serif font-semibold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 mb-8" data-id="element-38">
          Jetzt für meinen Hund entdecken →
        </a>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base font-serif text-brown-dark/70" data-id="element-39">
          <span className="flex items-center gap-2" data-id="element-40">
            <Check className="w-4 h-4 text-forest" data-id="element-41" /> Schneller Versand
          </span>
          <span className="flex items-center gap-2" data-id="element-42">
            <Check className="w-4 h-4 text-forest" data-id="element-43" /> Zufriedenheitsgarantie
          </span>
          <span className="flex items-center gap-2" data-id="element-44">
            <Check className="w-4 h-4 text-forest" data-id="element-45" /> 100% Natürliche
            Inhaltsstoffe
          </span>
        </div>
      </motion.div>
    </section>;
}